import { GridColumnAnimationSettings as GridColumnAnimationSettings_internal } from "./GridColumnAnimationSettings";
/**
 * Column animation settings for the grid.
*/
var IgrGridColumnAnimationSettings = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnAnimationSettings() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridColumnAnimationSettings.prototype.createImplementation = function () {
        return new GridColumnAnimationSettings_internal();
    };
    Object.defineProperty(IgrGridColumnAnimationSettings.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridColumnAnimationSettings.prototype.onImplementationCreated = function () {
    };
    IgrGridColumnAnimationSettings.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    return IgrGridColumnAnimationSettings;
}());
export { IgrGridColumnAnimationSettings };
//# sourceMappingURL=igr-grid-column-animation-settings.js.map
